import Tabs from "@/v2-backoffice-client/components/tabs"
import { useAddOnCatalogQuery } from "@/v2-backoffice-client/license/addOns/catalog/license.addOn.catalog.query"
import { LICENSING_VIEW_ADD_ONS } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's Add-ons tab trigger. Owns its own read of the catalog
// query — Apollo dedupes it against the board's — so the count stays live no
// matter which tab is open.
function LicenseAddOnTabTrigger() {
  const { data, loading } = useAddOnCatalogQuery()
  const addOnCount = (data?.getAddOnCatalog ?? []).length

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_ADD_ONS}
      iconSrc="puzzle"
      isLoading={loading}
      count={addOnCount}
    >
      Add-ons
    </Tabs.Trigger>
  )
}

export default LicenseAddOnTabTrigger
